<template>
  <el-select
    :value="orgId"
    :size="size"
    placeholder="Выберите организацию"
    style="width: 100%"
    filterable
    :loading="loading && !orgs.length"
    :disabled="disabled"
    clearable
    @change="change"
    @clear="clear"
  >
    <el-option
      v-for="org in allowedOrgs"
      :key="org.id_org"
      :label="org.org_name"
      :value="org.id_org"
    />
  </el-select>
</template>

<script>
import { ApiService } from "@/api";

export default {
  name: "SelectOrg",
  model: {
    prop: "org-id",
    event: "change",
  },
  props: {
    orgId: {
      type: [String, Number],
      default: null,
    },
    size: {
      type: String,
      default: "small",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      orgs: [],
    };
  },
  computed: {
    allowedOrgs() {
      const deniedOrgs = [41];

      return this.orgs.filter((org) => !deniedOrgs.includes(org.id_org));
    },
  },
  created() {
    ApiService.org
      .getListSelect()
      .then((orgs) => {
        this.orgs = orgs;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    change(id_org) {
      const selectedOrg = this.orgs.find((t) => t.id_org === id_org);
      this.$emit("change", selectedOrg);
    },
    clear() {
      this.$emit("clear");
    }
  },
};
</script>
